/**
 * Os prazos de uma partida, como o CLIENTE precisa conhecê-los.
 *
 * Os valores que mandam vivem no servidor (`apps/server/src/config.ts` e
 * `match.ts`), porque alguns são ajustáveis por variável de ambiente e o
 * servidor é quem tem o relógio. Mas a página de regras precisa dizer ao
 * jogador quanto tempo ele tem para tacar e o que acontece quando o tempo
 * acaba — e o pacote do servidor não é importável do site.
 *
 * Por isso os PADRÕES ficam aqui, no único pacote que os dois lados leem.
 * O teste ao lado (`prazos.test.ts`) lê o fonte do servidor e falha se um dos
 * dois mudar sem o outro: é o que impede a página de prometer 45 segundos
 * enquanto o servidor cobra 30.
 *
 * Nada aqui é esquema de mensagem. São números, e só.
 */

/** Quanto tempo o jogador tem para tacar antes de perder a vez. */
export const SHOT_CLOCK_MS = 45_000

/** Tempo para os dois revelarem o nonce antes de a partida ser anulada. */
export const REVEAL_TIMEOUT_MS = 60_000

/**
 * Prazo on-chain da partida, em segundos. Depois disso, o depósito volta aos
 * dois pelo contrato — é a rede de segurança para o caso de o servidor sumir.
 */
export const MATCH_TIMEOUT_SECONDS = 3600

/**
 * Teto de duração de uma partida, contado do começo dela. Estourou, a partida
 * acaba com vencedor: quem está na frente. Fica abaixo do prazo on-chain para
 * a liquidação ainda caber dentro dele.
 */
export const MATCH_MAX_DURATION_MS = Math.floor(MATCH_TIMEOUT_SECONDS * 1000 * 0.6)
